'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hoc = require('./hoc');

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createComponent = function createComponent(config) {
  var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = config.type,
      props = config.props,
      style = config.style,
      _config$propTypes = config.propTypes,
      propTypes = _config$propTypes === undefined ? {} : _config$propTypes;

  if (!config || !type || !style) return null;

  var _tag = components[type] || type;

  var Component = (0, _hoc2.default)(style, props)(_tag);

  Component.propTypes = propTypes;
  Component.defaultProps = config.defaultProps || {};

  return Component;
};

exports.default = createComponent;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/create-component.js
// module id = 251
// module chunks = 3